import { Api } from '../../../index';
import { BusinessInfo } from '../../../../types';
import { mapResponseToBusinessInfo } from './business-info-mapper';

export const getBookingsSettings = async (api: Api): Promise<BusinessInfo> => {
  const bookingsSettingsResponse = await api.getBookingsSettings();
  return mapResponseToBusinessInfo(bookingsSettingsResponse);
};
